/* eslint-disable */
import React, { createRef, useContext } from "react";
import axios from "axios";

const LinkPrivado = (props) => {
  const children = props.children;
  const usuario = props.usuario;
  const link = createRef();

  const descarga = async () => {
    if (link.current.href) {
      return;
    }
    try {
      await axios.get(`/api/votos/csv/${usuario.municipioId}`);
      await axios
        .get(`/api/private/votacion-${usuario.municipioId}.csv`)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "text/csv;charset=utf-8;",
          });
          const href = window.URL.createObjectURL(blob);

          link.current.download = `votacion-${usuario.municipioId}.csv`;
          link.current.href = href;

          link.current.click();
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <a
      className="btn ppr-btn-azul font-weight-bold m-2 btn-sm"
      ref={link}
      onClick={descarga}
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      {children}
    </a>
  );
};

export default LinkPrivado;
